import { render } from "./free-gift-promo.vue?vue&type=template&id=b51c1b8c"
import script from "./free-gift-promo.vue?vue&type=script&lang=js"
export * from "./free-gift-promo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__